<div class="list">
    <div *uiScroll="let item of datasource; let index = index" class="list__group">
      <ng-container *ngIf="item.isGroup; else itemTemplate">
        <div class="list__group__title">
          {{ item.title }}
        </div>
      </ng-container>
      <ng-template #itemTemplate>
        <div
          (click)="onClickItemList(item)"
          [ngClass]="{ 'is-selected': selectedItemList?.Id === item.Id }"
          class="list__group__item"
        >
            <div class="list__group__item__content">
                <app-event-item *ngIf="listEventType === EVENT_TYPE.Alarm" [eventData]="item"></app-event-item>
                <app-fuel-item *ngIf="listEventType === EVENT_TYPE.Fuel" [eventData]="item"></app-fuel-item>
                <app-area-item *ngIf="listEventType === EVENT_TYPE.Area" [eventData]="item"></app-area-item>
            </div>
        </div>
      </ng-template>
    </div>
</div>

